import { render, staticRenderFns } from "./TeleMarketUserGroupTypeConfig.vue?vue&type=template&id=a9d7766c&scoped=true"
import script from "./TeleMarketUserGroupTypeConfig.vue?vue&type=script&lang=js"
export * from "./TeleMarketUserGroupTypeConfig.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketUserGroupTypeConfig.vue?vue&type=style&index=0&id=a9d7766c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d7766c",
  null
  
)

export default component.exports